import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isAbsoluteUrl } from '@vxui/components';
import { Servers, Settings } from '../models';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.BASE_URL }),
  endpoints: builder => ({
    getSettings: builder.query<Settings, void>({
      query: () => 'env.json',
      transformResponse: (response: Settings) => {
        const result: Settings = {
          ...response,
          servers: {
            ...response.servers,
          },
        };
        if (import.meta.env.DEV) {
          Object.entries(response.servers)
            .filter(([_, value]) => !isAbsoluteUrl(value))
            .forEach(([key, value]) => {
              result.servers[key as keyof Servers] = `${response.baseUrl}${value}`;
            });
        }
        return result;
      },
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApi;
